export const dateTipeOptions = [
  { id: 1, label: 'Data da cotação', value: 'quotationDate' },
  { id: 2, label: 'Data da proposta', value: 'proposalDate' },
  { id: 3, label: 'Data da emissão', value: 'issueDate' },
  { id: 4, label: 'Data de cancelamento', value: 'cancellationDate' },
];
export const types = [
  {
    id: 1,
    label: 'Cotação',
    value: 'quotation',
  },
  {
    id: 2,
    label: 'Cotação cancelada',
    value: 'quotationCanceled',
  },
  {
    id: 3,
    label: 'Proposta',
    value: 'proposal',
  },
  {
    id: 4,
    label: 'Proposta recusada',
    value: 'proposalRefused',
  },
  {
    id: 5,
    label: 'Apólice',
    value: 'policy',
  },
  {
    id: 6,
    label: 'Apólice cancelada',
    value: 'policyCanceled',
  },
];
